<script setup lang="ts">
import { navigateTo } from '#app'
import SimpleHeader from '~/components/molecules/SimpleHeader.vue'
import SettingsSidebar from '~/components/organisms/Sidebars/SettingsSidebar.vue'
</script>

<template>
  <div>
    <SimpleHeader @back="() => navigateTo('/')" />
    <div class="columns">
      <nav class="sidebar is-narrow hero is-fullheight">
        <SettingsSidebar />
      </nav>
      <main class="column">
        <slot />
      </main>
    </div>
  </div>
</template>

<style lang="scss" scoped>
.sidebar {
  border-right: 1px solid var(--semantic-tokens-neutral-weak-border);
}

.columns {
  margin: 0;
}
</style>
